/**
 * TanStack Router: /revfinops
 *
 * This route file was auto-generated by the route generation script.
 * Component: RevFinOpsPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import RevFinOpsPage from '@/app/revfinops/page'

/**
 * Route: /revfinops
 * Layout: _auth (authenticated)
 * Component: RevFinOpsPage
 */
export const Route = createFileRoute('/_auth/revfinops/')({
  component: RevFinOpsPage,
})
